import axios from '@fs/zion-axios'
import React, { useEffect, useState } from 'react'
import { getSessionId } from '@fs/zion-session'

export default function TakeAwayImage({ takeAway, css, style, type }) {
  const [img, setImg] = useState(takeAway?.thumbnailUrl ?? takeAway?.url)
  useEffect(() => {
    if (takeAway?.memoryArtifactId) {
      const sessionId = getSessionId()
      axios.get(`/service/discovery/common/memory/${takeAway?.memoryArtifactId}`).then((res) => {
        if (type === 'thumbnail') {
          setImg(`${res.data?.thumbMobileUrl}&session=${sessionId}`)
        } else {
          setImg(`${res.data?.url}&session=${sessionId}`)
        }
      })
    } else {
      setImg(takeAway?.thumbnailUrl ?? takeAway?.url)
    }
  }, [takeAway, type])

  return <>{img && <img loading="lazy" src={img} alt="keepsake" css={css} style={style} />}</>
}
